module.exports = __webpack_public_path__ + "static/img/Lumen5-PrimaryLogo.4699c454.svg";